import React, { useContext }  from 'react';
import { NavLink } from 'react-router-dom';
import moment from 'moment';
import { AuthContext } from '../../context/auth-context';
import './NavLinks.css';
const NavLinks = props => {
  const auth = useContext(AuthContext);

  return <ul className="nav-links">
    {auth.isLoggedIn && ( 
    <li>
      <NavLink to="/" exact>Dashboard</NavLink>
    </li>
    )} 
    {auth.isLoggedIn && ( 
    <li>
      <NavLink to="/items">Inventory</NavLink>
    </li>
    )}
    {auth.isLoggedIn && (
      <li>
        <NavLink to="/consignments">Consignment</NavLink>
      </li>
    )}
    {auth.isLoggedIn && ( 
    <li>
      <NavLink to="/customers">Customers</NavLink>
    </li>
    )}
    {auth.isLoggedIn && ( 
    <li>
      <NavLink to="/orders">Sales</NavLink>
    </li>
    )}
    {auth.isLoggedIn && ( 
    <li>
      <NavLink to={`/appointments/${(moment().format('YYYY-MM-DD[T00:00:00.000Z]'))}`}>
        Appointments
      </NavLink>
    </li>
    )}
    {auth.isLoggedIn && ( 
    <li>
      <NavLink to="/specialOrders">Special-Orders</NavLink>
    </li>
    )}
    {auth.isLoggedIn && ( 
    <li>
      <NavLink to="/alterations">Alterations</NavLink>
    </li>
    )}
    {!auth.isLoggedIn && ( 
    <li>
      <NavLink to="/auth">LOGIN</NavLink>
    </li>
    )}
    {auth.isLoggedIn && ( 
    <li>
      <button onClick={auth.logout}>LOGOUT</button>
    </li>
    )}   
  </ul>
};

export default NavLinks;